import { useNavigate } from 'react-router-dom';
import '../styles/GetStartedFreeTrial.css';

const GetStartedFreeTrial = () => {
    const navigate = useNavigate();
    return (
        <section style={{ padding: "4rem 1rem", backgroundColor: "#ffffff", color: "#000", textAlign: "center" }}>
            <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>
                Start Managing Your Vehicle Rental Business Smarter
            </h2>

            <p style={{ fontSize: "1rem", maxWidth: "700px", margin: "0 auto 2rem" }}>
                Join rental businesses using RD Rental to automate bookings, manage fleets, and scale operations with ease.
            </p>

            <button
                onClick={() => navigate("/free-trial")}
                style={{
                    backgroundColor: "#167AC3",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    padding: "0.8rem 1.8rem",
                    borderRadius: "0.5rem",
                    border: "none",
                    cursor: "pointer",
                }}
            >
                Start Free Trial
            </button>
        </section>
    );
};

export default GetStartedFreeTrial;
